// extracted by mini-css-extract-plugin
module.exports = {"root":"Button_root__ySrX8","variant_primary":"Button_variant_primary__ilAk3","variant_secondary":"Button_variant_secondary__xGLc4"};